import { get } from 'lodash'

import { Container } from "@skinsoft/types"

export const id = (container: Container): string => get(container, 'id')

export const title = (container: Container): string => {
    // @ts-ignore
    return get(container, 'containerItemSchema.name')
}

export const identifier = (container: Container): string | undefined => {
    return get(container, 'identificationItemSchema.identifiers[0].identifier')
}

export const author = (container: Container): string | undefined => {
    return get(container, 'managementData.creatorUser')
}

export const futureLocation = (container: Container) => get(container, 'locationItemSchema.futureLocation.futureLocation')